export const clientBoughtStatus = {
  active: 'Активный',
  inactive: 'Не активный',
  off: 'Отключен',
};

export const clientBoughtStatusToColor = {
  active: 'green',
  inactive: 'red',
  off: 'gold',
};

export const serviceOffReasons = [
  'Приостановление ИП',
  'Закрытие ИП',
  'Перешли к штатному бухгалтеру',
  'Перешли к аутсорс бухгалтеру',
  'Перешли к самообслуживанию',
  'Ошибочно купил клиент',
  'Ошибочно добавили',
  'Смена тарифа',
  'Прочее',
];
